// @ts-nocheck
import {
  CFG,
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  SPELLS,
  SPELLS_IN_SLOT,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  eventKeyLabel,
  isLocalDev,
  isTeammate,
  itemCost,
  keyLabelForSlot,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  teamColor,
} from "../../data";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../../util";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
} from "../../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../../audio";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../../lobby";

import { Game } from "../game-base";

Game.prototype.drawChainBetween = function (c, x0, y0, x1, y1, opts) {
    opts = opts || {};
    const dx = x1 - x0, dy = y1 - y0;
    const dist = Math.hypot(dx, dy);
    if (dist < 6) return;
    const ang = Math.atan2(dy, dx);
    const linkLen = opts.linkLen || 12;
    const count = Math.max(1, Math.floor(dist / linkLen));
    const light = opts.light || "#c8b898";
    const dark = opts.dark || "#5c4e38";
    const thick = opts.width || 2.8;
    c.save();
    c.translate(x0, y0);
    c.rotate(ang);
    for (let i = 0; i < count; i++) {
      const x = (i + 0.5) * (dist / count);
      c.strokeStyle = i % 2 ? dark : light;
      c.lineWidth = thick;
      c.beginPath();
      c.ellipse(x, 0, linkLen * 0.42, thick * 0.95, 0, 0, TAU);
      c.stroke();
    }
    c.restore();
  }

Game.prototype.drawHookChains = function () {
    const c = this.ctx;
    for (const pr of this.projectiles) {
      if (pr.spellId !== "hook" || pr.ownerId == null) continue;
      const owner = this.playerById[pr.ownerId];
      if (!owner?.alive) continue;
      this.drawChainBetween(c, owner.x, owner.y, pr.x, pr.y, {
        light: "#c8b898", dark: "#5c4e38", width: 3, linkLen: 11,
      });
    }
  }

Game.prototype.drawHookHead = function (c, r, ang) {
    c.save();
    c.rotate(ang + Math.PI / 2);
    c.strokeStyle = "#6a5a42";
    c.lineWidth = r * 0.32;
    c.lineCap = "round";
    c.beginPath();
    c.moveTo(0, r * 1.1);
    c.lineTo(0, -r * 0.15);
    c.stroke();
    c.strokeStyle = "#a89472";
    c.lineWidth = r * 0.44;
    c.beginPath();
    c.arc(0, r * 0.2, r * 0.82, -Math.PI * 0.52, Math.PI * 0.78);
    c.stroke();
    c.fillStyle = "#e8dcc8";
    c.beginPath();
    c.moveTo(r * 0.68, r * 0.62);
    c.lineTo(r * 1.12, r * 0.18);
    c.lineTo(r * 0.82, r * 0.82);
    c.closePath();
    c.fill();
    c.strokeStyle = "#8a7560";
    c.lineWidth = r * 0.14;
    c.stroke();
    c.restore();
  }

Game.prototype.drawProjectiles = function () {
    const c = this.ctx;
    const t = this.nowS;
    for (const pr of this.projectiles) {
      const s = spellInfo(pr.spellId);
      if (s && s.fall) { this.drawMeteor(pr, s); continue; }
      // heading: from velocity offline, from snapshot delta online (interpolate)
      const ang = pr.ang != null ? pr.ang : Math.atan2(pr.vy || 0, pr.vx || 0);
      const r = pr.radius || 8;
      const col = pr.color;
      if (pr.spellId !== "voidglass_shard" && pr.spellId !== "hook") this.spawnTrail(pr, ang, r, col);

      c.save();
      c.translate(pr.x, pr.y);
      this.upright();
      switch (pr.spellId) {
        case "freeze":    this.drawIceShard(c, r, col, t, ang); break;
        case "frostspike":this.drawIceShard(c, r, col, t, ang); break;
        case "voidglass_shard": this.drawVoidglassShard(c, r, t, ang, pr.id); break;
        case "frozenorb": this.drawFrozenOrb(c, r, col, t); break;
        case "voidorb":   this.drawVoidOrb(c, r, col, t); break;
        case "icelance":
        case "boss_rime_lance":
        case "boss_add_frostbolt":
          this.drawGlacierSpear(c, r, col, ang); break;
        case "bonespear":  this.drawBoneSpear(c, r, ang); break;
        case "boomerang": this.drawBlade(c, r, col, t); break;
        case "homing":    this.drawOrbRing(c, r, col, t); break;
        case "splitter":  this.drawUnstable(c, r, col, t); break;
        case "swap":      this.drawHelix(c, r, col, t, ang); break;
        case "disable":   this.drawWebOrb(c, r, col, t); break;
        case "bouncer":   this.drawCrystalBall(c, r, col); break;
        case "hook":      this.drawHookHead(c, r, ang); break;
        case "link":      this.drawHook(c, r, col, ang); break;
        case "drain":     this.glowOrb(c, r, col, ang, "#ffd0e0"); break;
        case "fireball":
        case "firespray":
          this.drawFireballProjectile(c, pr, ang, t);
          break;
        case "boss_poison_spray":
          this.drawPoisonSprayProjectile(c, pr, ang, t);
          break;
        default:          this.glowOrb(c, r, col, ang, "#ffffff"); break;
      }
      c.restore();
    }
  }

Game.prototype.spawnTrail = function (pr, ang, r, col) {
    if (this.state !== "playing") return;
    const fire = pr.spellId === "fireball" || pr.spellId === "firespray";
    const poison = pr.spellId === "boss_poison_spray";
    const bone = pr.spellId === "bonespear";
    const bx = -Math.cos(ang), by = -Math.sin(ang);
    if (bone) {
      if (Math.random() < 0.92) {
        this.particles.push(new Particle(
          pr.x + bx * r * rand(0.25, 1.1) + rand(-2, 2), pr.y + by * r * rand(0.25, 1.1) + rand(-2, 2),
          bx * rand(-6, 6), by * rand(-6, 6),
          rand(0.38, 0.72), "#9a1828", r * rand(0.55, 1.05),
          { kind: "smoke", grav: 0, drag: 0.96 }));
      }
      return;
    }
    if (poison) {
      if (Math.random() < 0.92) {
        const spd = rand(12, 55);
        const c2 = Math.random() < 0.5 ? "#c8d040" : "#6a8a30";
        this.particles.push(new Particle(
          pr.x + bx * r * 0.35 + rand(-3, 3), pr.y + by * r * 0.35 + rand(-3, 3),
          bx * spd + rand(-12, 12), by * spd + rand(-12, 12),
          rand(0.14, 0.32), c2, r * rand(0.35, 0.65), { kind: "glow", grav: -30 }));
      }
      if (Math.random() < 0.2) {
        this.particles.push(new Particle(pr.x, pr.y, bx * 16 + rand(-8, 8), by * 16 + rand(-8, 8),
          rand(0.35, 0.65), "#4a2848", r * 0.55, { kind: "smoke", grav: -35 }));
      }
      return;
    }
    if (fire) {
      if (!fireballSpriteFXEnabled(pr.spellId)) {
        if (Math.random() < 0.95) {
          const spd = rand(15, 70);
          const c2 = Math.random() < 0.5 ? "#ffd479" : "#ff7a2f";
          this.particles.push(new Particle(
            pr.x + bx * r * 0.4 + rand(-3, 3), pr.y + by * r * 0.4 + rand(-3, 3),
            bx * spd + rand(-16, 16), by * spd + rand(-16, 16),
            rand(0.16, 0.34), c2, r * rand(0.4, 0.8), { kind: "glow", grav: -50 }));
        }
        if (Math.random() < 0.25) {
          this.particles.push(new Particle(pr.x, pr.y, bx * 20 + rand(-10, 10), by * 20 + rand(-10, 10),
            rand(0.4, 0.7), "#2a201c", r * 0.7, { kind: "smoke", grav: -40 }));
        }
        return;
      }
      if (Math.random() < 0.5) {
        this.particles.push(new Particle(pr.x, pr.y, bx * 20 + rand(-10, 10), by * 20 + rand(-10, 10),
          rand(0.4, 0.7), "#2a201c", r * 0.7, { kind: "smoke", grav: -40 }));
      }
      return;
    }
    const iceLance = pr.spellId === "icelance" || pr.spellId === "boss_rime_lance" || pr.spellId === "boss_add_frostbolt";
    if (iceLance) {
      if (Math.random() < 0.92) {
        const spd = rand(10, 44);
        this.particles.push(new Particle(
          pr.x + bx * r * 0.35 + rand(-2, 2), pr.y + by * r * 0.35 + rand(-2, 2),
          bx * spd + rand(-8, 8), by * spd + rand(-8, 8),
          rand(0.14, 0.3), "#c8f0ff", r * rand(0.28, 0.55), { kind: "glow", grav: 0 }));
      }
      return;
    }
    if (Math.random() < 0.95) {
      const spd = rand(15, 70);
      this.particles.push(new Particle(
        pr.x + bx * r * 0.4 + rand(-3, 3), pr.y + by * r * 0.4 + rand(-3, 3),
        bx * spd + rand(-16, 16), by * spd + rand(-16, 16),
        rand(0.16, 0.34), col, r * rand(0.4, 0.8), { kind: "glow" }));
    }
  }

Game.prototype.glowOrb = function (c, r, col, ang, coreCol) {
    c.save();
    c.globalCompositeOperation = "lighter";
    // comet tail (a soft triangle fading out behind the heading)
    c.save();
    c.rotate(ang);
    c.fillStyle = this.grad("orbtail:" + r + ":" + col, c2 => {
      const grad = c2.createLinearGradient(-r * 3.6, 0, r * 0.4, 0);
      grad.addColorStop(0, rgba(col, 0));
      grad.addColorStop(1, rgba(col, 0.6));
      return grad;
    });
    c.beginPath(); c.moveTo(0, -r * 0.75); c.lineTo(-r * 3.6, 0); c.lineTo(0, r * 0.75); c.closePath(); c.fill();
    c.restore();
    // body halo + disc
    c.globalAlpha = 0.4; c.fillStyle = col;
    c.beginPath(); c.arc(0, 0, r * 1.8, 0, TAU); c.fill();
    c.globalAlpha = 0.85;
    c.beginPath(); c.arc(0, 0, r, 0, TAU); c.fill();
    c.restore();
    // bright core (normal blend so it stays crisp)
    c.fillStyle = coreCol || "#ffffff"; c.globalAlpha = 0.95;
    c.beginPath(); c.arc(0, 0, r * 0.45, 0, TAU); c.fill();
    c.globalAlpha = 1;
  }

Game.prototype.drawIceShard = function (c, r, col, t, ang) {
    c.save();
    c.globalCompositeOperation = "lighter";
    c.globalAlpha = 0.3; c.fillStyle = col;
    c.beginPath(); c.arc(0, 0, r * 1.9, 0, TAU); c.fill();
    c.restore();
    c.save();
    c.rotate(t * 3 + ang);
    const R = r * 1.8;
    c.fillStyle = "rgba(214,246,255,0.95)";
    c.strokeStyle = col; c.lineWidth = 1.5;
    c.beginPath();
    c.moveTo(0, -R); c.lineTo(r * 0.85, -r * 0.3); c.lineTo(r * 0.6, R * 0.7);
    c.lineTo(-r * 0.6, R * 0.7); c.lineTo(-r * 0.85, -r * 0.3); c.closePath();
    c.fill(); c.stroke();
    c.fillStyle = "rgba(255,255,255,0.9)";
    c.beginPath(); c.moveTo(0, -R); c.lineTo(r * 0.32, -r * 0.2); c.lineTo(-r * 0.2, r * 0.35); c.closePath(); c.fill();
    c.restore();
  }

// Razor debris sheared from a Voidglass orb — small, fast, tumbling glass splinters.
Game.prototype.drawVoidglassShard = function (c, r, t, ang, id) {
  const seed = ((id || 0) * 17.31 + 0.5) % 997;
  const jit = (i) => { const h = Math.sin(seed * 0.13 + i * 41.7) * 43758.5453; return h - Math.floor(h); };
  const spin = t * (20 + jit(0) * 8) + seed * 0.07;
  const tumble = t * (13 + jit(1) * 6) + seed * 0.11;
  const shardLen = r * (2.8 + jit(2) * 1.4);
  const shardW = r * (0.22 + jit(3) * 0.18);

  // speed streak along flight path
  c.save();
  c.rotate(ang);
  c.globalCompositeOperation = "lighter";
  c.globalAlpha = 0.28;
  const sg = c.createLinearGradient(-shardLen * 1.8, 0, r * 0.4, 0);
  sg.addColorStop(0, "rgba(180,230,255,0)");
  sg.addColorStop(0.35, "rgba(200,240,255,0.45)");
  sg.addColorStop(1, "rgba(255,200,140,0.55)");
  c.fillStyle = sg;
  c.beginPath();
  c.moveTo(-shardLen * 1.6, -shardW * 1.2);
  c.lineTo(r * 0.55, -shardW * 0.35);
  c.lineTo(r * 0.55, shardW * 0.35);
  c.lineTo(-shardLen * 1.6, shardW * 1.2);
  c.closePath();
  c.fill();
  c.restore();

  c.save();
  c.rotate(spin);
  c.scale(1, 0.55 + 0.45 * Math.abs(Math.sin(tumble)));

  // dark void core edge
  c.fillStyle = "rgba(12,18,32,0.92)";
  c.strokeStyle = "rgba(8,14,28,0.95)";
  c.lineWidth = 1.1;
  c.beginPath();
  c.moveTo(shardLen, 0);
  c.lineTo(shardLen * 0.15, -shardW);
  c.lineTo(-shardLen * 0.55, -shardW * 0.55);
  c.lineTo(-shardLen * 0.75, 0);
  c.lineTo(-shardLen * 0.55, shardW * 0.55);
  c.lineTo(shardLen * 0.15, shardW);
  c.closePath();
  c.fill();
  c.stroke();

  // glass face
  c.fillStyle = "rgba(200,240,255,0.92)";
  c.beginPath();
  c.moveTo(shardLen * 0.92, 0);
  c.lineTo(shardLen * 0.08, -shardW * 0.72);
  c.lineTo(-shardLen * 0.35, 0);
  c.lineTo(shardLen * 0.08, shardW * 0.72);
  c.closePath();
  c.fill();

  // razor highlight
  c.strokeStyle = "rgba(255,252,255,0.85)";
  c.lineWidth = 0.9;
  c.beginPath();
  c.moveTo(shardLen * 0.88, 0);
  c.lineTo(shardLen * 0.05, -shardW * 0.45);
  c.stroke();

  // ember glint from meteor forge
  c.globalCompositeOperation = "lighter";
  c.fillStyle = "rgba(255,176,96,0.55)";
  c.beginPath();
  c.moveTo(-shardLen * 0.2, -shardW * 0.25);
  c.lineTo(-shardLen * 0.45, 0);
  c.lineTo(-shardLen * 0.2, shardW * 0.25);
  c.closePath();
  c.fill();

  c.restore();
};

Game.prototype.drawFrozenOrb = function (c, r, col, t) {
    c.save();
    c.globalCompositeOperation = "lighter";
    // broad frosty aura
    c.globalAlpha = 0.22; c.fillStyle = col;
    c.beginPath(); c.arc(0, 0, r * 2.4, 0, TAU); c.fill();
    c.globalAlpha = 0.4;
    c.beginPath(); c.arc(0, 0, r * 1.5, 0, TAU); c.fill();
    c.restore();
    // rotating ring of spikes around the rim
    c.save();
    c.rotate(t * 7);
    c.fillStyle = "rgba(200,240,255,0.9)";
    c.strokeStyle = col; c.lineWidth = 1;
    const spikes = 8;
    for (let i = 0; i < spikes; i++) {
      c.save();
      c.rotate((i / spikes) * TAU);
      c.beginPath();
      c.moveTo(0, -r * 1.7); c.lineTo(r * 0.26, -r * 0.95); c.lineTo(-r * 0.26, -r * 0.95);
      c.closePath(); c.fill();
      c.restore();
    }
    c.restore();
    // glassy core
    c.fillStyle = "rgba(120,210,255,0.85)"; c.globalAlpha = 0.9;
    c.beginPath(); c.arc(0, 0, r * 0.95, 0, TAU); c.fill();
    c.fillStyle = "rgba(240,252,255,0.95)";
    c.beginPath(); c.arc(-r * 0.25, -r * 0.25, r * 0.4, 0, TAU); c.fill();
    c.globalAlpha = 1;
  }

Game.prototype.drawVoidOrb = function (c, r, col, t) {
    c.save();
    c.globalCompositeOperation = "lighter";
    const pulse = 0.72 + 0.28 * Math.sin(t * 14);
    c.globalAlpha = 0.18 + 0.12 * Math.sin(t * 22);
    c.fillStyle = col;
    c.beginPath(); c.arc(0, 0, r * 2.6 * pulse, 0, TAU); c.fill();
    c.globalAlpha = 0.35 + 0.15 * Math.sin(t * 18);
    c.beginPath(); c.arc(0, 0, r * 1.6 * pulse, 0, TAU); c.fill();
    c.restore();
    c.save();
    c.rotate(t * 9);
    c.globalCompositeOperation = "lighter";
    c.fillStyle = "#c4a8ff";
    for (let i = 0; i < 6; i++) {
      const a = i / 6 * TAU + t * 6;
      const rr = r * (1.35 + 0.45 * Math.sin(t * 20 + i));
      c.save(); c.translate(Math.cos(a) * rr, Math.sin(a) * rr); c.rotate(a + t * 4);
      c.fillRect(-1.5, -4, 3, 8); c.restore();
    }
    c.restore();
    c.fillStyle = "rgba(40,10,80,0.92)"; c.globalAlpha = 0.95;
    c.beginPath(); c.arc(0, 0, r * 0.88 * pulse, 0, TAU); c.fill();
    c.fillStyle = "rgba(180,140,255,0.85)";
    c.beginPath(); c.arc(-r * 0.22, -r * 0.22, r * 0.32 * pulse, 0, TAU); c.fill();
    c.globalAlpha = 1;
  }

Game.prototype.drawBoneSpear = function (c, r, ang) {
    c.save();
    c.rotate(ang);
    c.fillStyle = "#f4f0e8";
    c.strokeStyle = "#c8bfb0";
    c.lineWidth = 1.5;
    c.beginPath();
    c.moveTo(r * 2.2, 0);
    c.lineTo(r * 0.12, -r * 0.32);
    c.lineTo(-r * 1.55, -r * 0.2);
    c.lineTo(-r * 1.55, r * 0.2);
    c.lineTo(r * 0.12, r * 0.32);
    c.closePath();
    c.fill();
    c.stroke();
    c.fillStyle = "#ffffff";
    c.beginPath();
    c.moveTo(r * 2.2, 0);
    c.lineTo(r * 0.45, -r * 0.1);
    c.lineTo(r * 0.45, r * 0.1);
    c.closePath();
    c.fill();
    c.restore();
  }

Game.prototype.drawGlacierSpear = function (c, r, col, ang) {
    c.save();
    // frosty halo
    c.globalCompositeOperation = "lighter";
    c.globalAlpha = 0.28; c.fillStyle = col;
    c.beginPath(); c.arc(0, 0, r * 2.0, 0, TAU); c.fill();
    c.restore();
    c.save();
    c.rotate(ang);
    // elongated crystalline lance
    c.fillStyle = "rgba(200,238,255,0.95)";
    c.strokeStyle = col; c.lineWidth = 2;
    c.beginPath();
    c.moveTo(r * 2.1, 0);            // tip (leading)
    c.lineTo(r * 0.2, -r * 0.85);
    c.lineTo(-r * 1.7, -r * 0.45);   // tail
    c.lineTo(-r * 1.7, r * 0.45);
    c.lineTo(r * 0.2, r * 0.85);
    c.closePath(); c.fill(); c.stroke();
    // bright inner facet
    c.fillStyle = "rgba(255,255,255,0.9)";
    c.beginPath(); c.moveTo(r * 2.1, 0); c.lineTo(r * 0.1, -r * 0.3); c.lineTo(-r * 0.9, 0); c.lineTo(r * 0.1, r * 0.3); c.closePath(); c.fill();
    c.restore();
  }

Game.prototype.drawBlade = function (c, r, col, t) {
    c.save();
    c.rotate(t * 17);
    c.globalCompositeOperation = "lighter";
    c.strokeStyle = col; c.globalAlpha = 0.35; c.lineWidth = r * 0.9; c.lineCap = "round";
    c.beginPath(); c.arc(0, 0, r * 1.6, 0, Math.PI * 1.4); c.stroke();
    c.lineCap = "butt"; c.globalAlpha = 1;
    c.globalCompositeOperation = "source-over";
    c.fillStyle = col;
    c.beginPath();
    c.arc(0, 0, r * 1.8, -0.5, 1.0);
    c.arc(0, 0, r * 1.0, 1.0, -0.5, true);
    c.closePath(); c.fill();
    c.strokeStyle = "#fff6d0"; c.lineWidth = 1.5; c.stroke();
    c.restore();
  }

Game.prototype.drawOrbRing = function (c, r, col, t) {
    c.save();
    c.globalCompositeOperation = "lighter";
    c.fillStyle = col; c.globalAlpha = 0.3;
    c.beginPath(); c.arc(0, 0, r * 1.9, 0, TAU); c.fill();
    c.globalAlpha = 0.85;
    c.beginPath(); c.arc(0, 0, r, 0, TAU); c.fill();
    for (let i = 0; i < 3; i++) {
      const a = t * 6 + i * TAU / 3;
      c.globalAlpha = 0.9;
      c.beginPath(); c.arc(Math.cos(a) * r * 2.0, Math.sin(a) * r * 1.1, r * 0.32, 0, TAU); c.fill();
    }
    c.restore();
    c.fillStyle = "#ffffff"; c.globalAlpha = 0.95;
    c.beginPath(); c.arc(0, 0, r * 0.42, 0, TAU); c.fill();
    c.globalAlpha = 1;
  }

Game.prototype.drawUnstable = function (c, r, col, t) {
    c.save();
    c.globalCompositeOperation = "lighter";
    c.fillStyle = col; c.globalAlpha = 0.4 + 0.2 * Math.sin(t * 30);
    c.beginPath(); c.arc(0, 0, r * 1.7, 0, TAU); c.fill();
    c.globalAlpha = 0.9;
    c.beginPath(); c.arc(0, 0, r * 0.8, 0, TAU); c.fill();
    c.fillStyle = "#fff6d0";
    for (let i = 0; i < 6; i++) {
      const a = i / 6 * TAU + t * 8;
      const rr = r * (1.4 + 0.4 * Math.sin(t * 20 + i));
      c.save(); c.translate(Math.cos(a) * rr, Math.sin(a) * rr); c.rotate(a);
      c.fillRect(-1.5, -3, 3, 6); c.restore();
    }
    c.restore();
    c.globalAlpha = 1;
  }

Game.prototype.drawHelix = function (c, r, col, t, ang) {
    c.save();
    c.rotate(ang);
    c.globalCompositeOperation = "lighter";
    for (let s = -1; s <= 1; s += 2) {
      c.strokeStyle = col; c.globalAlpha = 0.85; c.lineWidth = 2.2;
      c.beginPath();
      for (let i = 0; i <= 16; i++) {
        const f = i / 16, x = (f - 0.5) * r * 4, y = Math.sin(f * Math.PI * 3 + t * 14) * r * 0.9 * s;
        i ? c.lineTo(x, y) : c.moveTo(x, y);
      }
      c.stroke();
    }
    c.fillStyle = "#ffffff"; c.globalAlpha = 0.95;
    c.beginPath(); c.arc(0, 0, r * 0.5, 0, TAU); c.fill();
    c.restore();
    c.globalAlpha = 1;
  }

Game.prototype.drawWebOrb = function (c, r, col, t) {
    c.save();
    c.globalCompositeOperation = "lighter";
    c.fillStyle = col; c.globalAlpha = 0.3;
    c.beginPath(); c.arc(0, 0, r * 1.7, 0, TAU); c.fill();
    c.globalAlpha = 0.85;
    c.beginPath(); c.arc(0, 0, r * 0.8, 0, TAU); c.fill();
    c.rotate(t * 2);
    c.strokeStyle = col; c.globalAlpha = 0.7; c.lineWidth = 1.5;
    for (let i = 0; i < 6; i++) {
      const a = i / 6 * TAU;
      c.beginPath(); c.moveTo(0, 0); c.lineTo(Math.cos(a) * r * 2.0, Math.sin(a) * r * 2.0); c.stroke();
    }
    c.beginPath(); c.arc(0, 0, r * 1.3, 0, TAU); c.stroke();
    c.restore();
    c.globalAlpha = 1;
  }

Game.prototype.drawCrystalBall = function (c, r, col) {
    c.save();
    c.globalCompositeOperation = "lighter";
    c.fillStyle = col; c.globalAlpha = 0.35;
    c.beginPath(); c.arc(0, 0, r * 1.8, 0, TAU); c.fill();
    c.restore();
    c.fillStyle = this.grad("crystal:" + r + ":" + col, c2 => {
      const g = c2.createRadialGradient(-r * 0.3, -r * 0.3, r * 0.1, 0, 0, r);
      g.addColorStop(0, "#ffffff"); g.addColorStop(0.45, col); g.addColorStop(1, shade(col, 0.5));
      return g;
    });
    c.beginPath(); c.arc(0, 0, r, 0, TAU); c.fill();
    c.fillStyle = "rgba(255,255,255,0.9)";
    c.beginPath(); c.arc(-r * 0.35, -r * 0.35, r * 0.24, 0, TAU); c.fill();
  }

Game.prototype.drawHook = function (c, r, col, ang) {
    c.save();
    c.rotate(ang + Math.PI / 2);
    c.save();
    c.globalCompositeOperation = "lighter";
    c.fillStyle = col; c.globalAlpha = 0.3;
    c.beginPath(); c.arc(0, 0, r * 1.7, 0, TAU); c.fill();
    c.restore();
    c.strokeStyle = col; c.lineWidth = r * 0.5; c.lineCap = "round";
    c.beginPath(); c.arc(0, r * 0.3, r * 0.9, -Math.PI * 0.5, Math.PI * 0.9); c.stroke();
    c.fillStyle = "#fff6d0";
    c.beginPath(); c.moveTo(r * 0.9, r * 0.3); c.lineTo(r * 1.5, 0); c.lineTo(r * 1.1, r * 0.8); c.closePath(); c.fill();
    c.lineCap = "butt";
    c.restore();
  }
